import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavigationBar } from '../component/NavigationBar/NavigationBar';
import { FooterComponent } from './Footer/Footer';

export interface ILayoutComponentProps {}

const LayoutComponent: React.FunctionComponent<ILayoutComponentProps> = (props) => {
  return (
    <>
      <header>
        <h1 className="brandName">Woman'sChoice</h1>
        <NavigationBar />
      </header>
      <main className="see">
        <Outlet />
      </main>
      <FooterComponent />
    </>
  );
};

export { LayoutComponent };
